import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber, CountryCode } from 'libphonenumber-js/min';

@Pipe({
    name: 'phone',
    standalone: false
})
export class PhonePipe implements PipeTransform {

    transform(phoneValue: number | string, country: string): any {
        try {
            let value = phoneValue + '';
            const digits = value.replace(/\D/g, '');
            // normalize to E.164
            if (digits.length === 10) {
                value = '+1' + digits;
            } else if (digits.length === 11) {
                value = '+' + digits;
            }
            const phoneNumber = parsePhoneNumber(value, country as CountryCode);
            return phoneNumber.formatNational();
        } catch (error) {
            return phoneValue;
        }
    }
}